import { render, staticRenderFns } from "./CustomLabel.vue?vue&type=template&id=584b01bc&scoped=true&"
import script from "./CustomLabel.vue?vue&type=script&lang=js&"
export * from "./CustomLabel.vue?vue&type=script&lang=js&"
import style0 from "./CustomLabel.vue?vue&type=style&index=0&id=584b01bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b01bc",
  null
  
)

export default component.exports